// import * as React from 'react';
// import styled from 'styled-components';
// import { useTranslation } from 'react-i18next';

// type Props = {

// }
// export const BackupcardTitle: React.FC<Props> = (props) => {
//   const [t, i18n] = useTranslation();
//   const BackupcardTitleComponent = styled.p`
//      font-weight: bold;
//      margin-top: -30px;
//      color:black;
//   `;
//   const BackupcardTitleImageComponent = styled.img`
//     height: 40px;
//     align-items: center;
//   `;
//   const Title2 = styled.p`
//     font-size: 13px;
//   `;
//   return (
//     <BackupcardTitleComponent>
//         <BackupcardTitleImageComponent id="backupcardhead" src="https://nfttopshot-template.onrender.com/template-images/logo.png"/>{t('NFTバックアップカード')}
//         <Title2>{t('スクリーンショットで保存してください')}</Title2>
//     </BackupcardTitleComponent>
//   );
// };


import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box } from '@chakra-ui/react';

type Props = {

}
export const BackupcardTitle: React.FC<Props> = (props) => {
  const [t, i18n] = useTranslation();
  const BackupcardTitleComponent = styled.p`
     font-weight: bold;
     color:black;
     margin-top: 6px;
  `;
  const BackupcardTitleImageComponent = styled.img`
    height: 40px;
    align-items: center;
  `;
  const Title2 = styled.p`
    font-size: 13px;
    color: red;
    font-family: monospace;
  `;
  return (
    <>
      <Box
        display={'flex'}
        mt={'-10px'}
      >
        <BackupcardTitleImageComponent id="backupcardhead" src="https://nfttopshot-template.onrender.com/template-images/logo.png"/>
        <BackupcardTitleComponent>{t('NFTバックアップカード')}</BackupcardTitleComponent>
      </Box>
      {/* <Title2>{t('スクリーンショットで保存してください')}</Title2> */}
    </>
  );
};